import { Container, Link } from '@cluey/cluey-components';
import { useEffect } from 'react';

import loudspeakerIcon from '../../../assets/images/loudspeaker-icon 2.svg';
import { scrollToTop } from '../../../util/helpers';
import { PATH_HUB_SUPPORT } from '../../../util/pagePath';
import articles, { Article } from './articles';

const HubUpdates = () => {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <Container className="px-4 py-7 md:py-8 lg:mb-0">
        <Link className="mb-2 text-xs font-bold uppercase" to={PATH_HUB_SUPPORT}>
          Support
        </Link>
        <h2 className="mb-14 font-display text-4xl font-bold tracking-[1px] md:text-[40px]">Customer Hub updates</h2>
        <div className="flex flex-row items-center pb-10">
          <img className="mr-10" alt="Announcement icon" src={loudspeakerIcon} />
          <div className="sm:w-1/2">
            <b>Learn more about the latest updates and what's new in Customer Hub</b>
          </div>
        </div>
        <div>
          {articles.map((article) => (
            <Article key={article.name} data={article} />
          ))}
        </div>
      </Container>
    </>
  );
};

export default HubUpdates;
